import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from '../../environments/environment';
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class UserRoleService {
  getAllContractsUrl = environment.apiBaseUrl + "UserRole/getuserroles";
  constructor(protected http: HttpClient) {
  }

  getUserRoles(): Observable<UserRole[]> {
    let url = this.getAllContractsUrl;
    return this.http.get<UserRole[]>(url);
  }
}

export class UserRole {
  userName: number;
  apexId: string;
  isIGAdmin: boolean;
  isIGPower: boolean;
  isIGAmerica: boolean;
  isIGEurope: boolean;
  isIGAsia: boolean;
  isTGEEAdmin: boolean;
  isTGEEPower: boolean;
  isTGEEViewer: boolean;
}